<template>
  <div class="page">
    <div class="category-main">
      <div class="category-item">
        <div class="category-key">分类类目:</div>
        <div class="category-val">
          <b-goods-category isEdit isInit @success="getCategoryActiveList" />
        </div>
      </div>

      <!-- 材质维护 -->
      <div v-if="categoryLastId" class="category-item">
        <div class="category-key">材质维护:</div>
        <div class="category-val">
          <ModuleCaizhi
            :list.sync="caizhiList"
            :categoryIds="categoryActiveIds"
            :obj="categoryLastActiveObj"
            @success="getModuleCaizhiList"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleCaizhi from './common/module-caizhi'
export default {
  components: { ModuleCaizhi },
  data() {
    return {
      categoryLastId: '',
      categoryActiveList: [],
      categoryActiveIds: [],
      caizhiList: []
    }
  },
  computed: {
    // 类目末级选中对象
    categoryLastActiveObj() {
      let result = ''
      let len = this.categoryActiveList.length
      if (len) result = this.categoryActiveList[len - 1]
      return result
    }
  },
  watch: {
    categoryLastActiveObj(newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        if (newVal.has_children) {
          this.categoryLastId = ''
        } else {
          this.categoryLastId = newVal.id
          this.$nextTick(() => {
            this.getModuleCaizhiList()
          })
        }
      }
    }
  },
  methods: {
    // 获取选中类目列表
    getCategoryActiveList(list) {
      this.categoryActiveList = []
      this.categoryActiveIds = []
      list.forEach((itemSt) => {
        itemSt.category.forEach((itemNd) => {
          if (itemSt.title.active_id === itemNd.id) {
            this.categoryActiveList.push(this.$util.deepCopy(itemNd))
            this.categoryActiveIds.push(itemNd.id)
          }
        })
      })
    },
    // 获取模块-材质列表
    getModuleCaizhiList() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/midu/list',
        params: {
          id: this.categoryLastId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.caizhiList = res.data.list
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 10px;
  .category-main {
    .category-item {
      display: flex;
      & ~ .category-item {
        margin-top: 10px;
      }
      .category-key {
        width: 108px;
        margin-right: 5px;
        line-height: 28px;
        text-align: right;
      }
      .category-val {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
